import React, { ReactNode } from 'react';
import styled from 'styled-components';

interface ColoredBadgeProps {
  children: ReactNode;
  index?: number;
}

const BadgeWrapper = styled.span<{ index: number }>`
  background-color: ${props => 
    props.index % 3 === 0 ? '#e6f7ed' : 
    props.index % 3 === 1 ? '#e6f1ff' : 
    '#fff8e6'
  };
  padding: 0.45rem 1rem;
  border-radius: 2rem;
  font-size: 0.85rem;
  font-weight: 600;
  display: flex;
  align-items: center;
  color: ${props => 
    props.index % 3 === 0 ? '#1e7e34' : 
    props.index % 3 === 1 ? '#0056b3' : 
    '#d39e00'
  };
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.05);
  transition: all 0.2s ease;
  position: relative;
  overflow: hidden;
  
  &::after {
    content: '';
    position: absolute;
    top: -50%;
    left: -50%;
    width: 200%;
    height: 200%;
    background: linear-gradient(
      rgba(255, 255, 255, 0.3),
      rgba(255, 255, 255, 0)
    );
    transform: rotate(30deg);
    pointer-events: none;
  }
  
  @media (min-width: 768px) {
    padding: 0.5rem 1.1rem;
    font-size: 0.9rem;
  }
  
  &::before {
    content: '';
    display: inline-block;
    width: 0.5rem;
    height: 0.5rem;
    background-color: ${props => 
      props.index % 3 === 0 ? '#28a745' : 
      props.index % 3 === 1 ? '#007bff' : 
      '#ffc107'
    };
    border-radius: 50%;
    margin-right: 0.5rem;
    box-shadow: 0 0 0 2px ${props => 
      props.index % 3 === 0 ? 'rgba(40, 167, 69, 0.3)' : 
      props.index % 3 === 1 ? 'rgba(0, 123, 255, 0.3)' : 
      'rgba(255, 193, 7, 0.3)'
    };
  }
  
  &:hover {
    transform: translateY(-1px);
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    background-color: ${props => 
      props.index % 3 === 0 ? '#d4f0de' : 
      props.index % 3 === 1 ? '#d6e8ff' : 
      '#fff0c7'
    };
  }
`;

// Variable global para mantener un contador
let badgeCounter = 0;

const ColoredBadge: React.FC<ColoredBadgeProps> = ({ children, index }) => {
  // Si no se proporciona un índice, usamos el contador y lo incrementamos
  if (index === undefined) {
    index = badgeCounter % 3;
    badgeCounter++;
  }
  
  return (
    <BadgeWrapper index={index}>
      {children}
    </BadgeWrapper>
  );
};

export default ColoredBadge; 